import { ApolloError, ApolloQueryResult } from '@apollo/client';
import {
  AvailabilityCheck,
  Exact,
  GetSchedulePortalAvailabilityCheckInput,
  GetSchedulePortalAvailabilityCheckQuery,
  useGetSchedulePortalAvailabilityCheckQuery,
} from '@shared/generated/graphql';

type Props = {
  shipmentId: string;
  index: number;
  movementStopId: string;
};

type QueryResult = {
  check?: AvailabilityCheck;
  loading: boolean;
  error?: ApolloError;
  refetch: (
    variables?:
      | Partial<Exact<{ input: GetSchedulePortalAvailabilityCheckInput }>>
      | undefined
  ) => Promise<ApolloQueryResult<GetSchedulePortalAvailabilityCheckQuery>>;
};

export function useGetAvailabilityCheck(props: Props): QueryResult {
  const { shipmentId, index: stopsIndex, movementStopId } = props;
  const fields = {};
  const input = {
    shipmentId,
    stopsIndex,
    fields,
    movementStopId,
  };
  const variables = { input };
  const result = useGetSchedulePortalAvailabilityCheckQuery({ variables });
  const { data, loading, error, refetch } = result;
  const check = data?.getSchedulePortalAvailabilityCheck.check;
  return { check, loading, error, refetch };
}
